/* global gapi */
import React, {Component} from 'react';
import {Col, Row, Button, ButtonGroup} from 'reactstrap';
let C = require('../constants').PERMISSIONS;

class Navbar extends Component {

  constructor(props) {
    super(props)
    this.changePage = this.changePage.bind(this)
    this.logout = this.logout.bind(this)
    this.makeButton = this.makeButton.bind(this)

    this.buttons = [
      {key: 'lopStatus',text: 'LOP Status',  permissions: C.VIEW},
      // {key: 'students', text: 'Students',    permissions: C.EDIT_STUDENT},
      {key: 'tardy',    text: 'Tardy sweep', permissions: C.TARDY},
      {key: 'check',    text: 'Check',       permissions: C.VIEW},
      {key: 'rosters',  text: 'Rosters',     permissions: C.VIEW},
      {key: 'library',  text: 'Library',     permissions: C.UPDATE_LIBRARY},
      {key: 'gpa',      text: 'GPA',         permissions: C.UPDATE_GPA},
      {key: 'reports',  text: 'Reports',     permissions: C.REPORTS},
      {key: 'users',    text: 'Users',       permissions: C.USERS}
    ]
  }

  changePage(evt) {
    let newPage = evt.target.getAttribute('data-key')
    this.props.dispatch('NAVBAR:CHANGE_ACTIVE_PAGE', newPage);
  }

  logout() {
    let _this = this
    var auth2 = gapi.auth2.getAuthInstance()
    auth2.signOut().then(function() {
      window.location = "https://accounts.google.com/Logout?hl=en";
      _this.props.dispatch('AUTH:LOGOUT')
    })
  }

  makeButton(item, activePage, onClick) {
    if ((item.permissions & this.props.user.permissions) > 0) {
      return (<Button key={item.key}
                      data-key={item.key}
                      onClick={onClick}
                      color={(activePage === item.key) ? 'primary' : 'secondary'}>{item.text}</Button>)
    } else {
      return null
    }
  }

  getButtons() {
    let activePage = this.props.activePage
    return (
      <div>
        <div className="center-buttons">
          <ButtonGroup>
            {
              this.buttons.map(item => this.makeButton(item, activePage, this.changePage))
            }
          </ButtonGroup>
          {
            (this.props.user.permissionFlags.VIEW_BY_STUDENT === 'true') ? null :
              <ButtonGroup className="navbar-left-separator">
                <a href="https://docs.google.com/document/d/1DL2hkbq6USGRnWJKw7p9V8b6Sj_F4gO_A9jgZf0m5E0" target="_blank" rel="noopener noreferrer">
                  <Button color="secondary">Instructions</Button>
                </a>
              </ButtonGroup>
          }
          <ButtonGroup className="navbar-left-separator">
            <Button onClick={this.logout} color="secondary">Logout</Button>
          </ButtonGroup>
        </div>
      </div>
    )
  }

  render() {
    return (
      <Row>
        <Col md={12}>
          {this.getButtons()}
        </Col>
      </Row>
    )
  }

}

export default Navbar



// WEBPACK FOOTER //
// ./src/views/Navbar.js